import * as Yup from 'yup';
import { Fields } from './types';

export const validationSchema = Yup.object({
  [Fields.platform]: Yup.string().required('  '),
  [Fields.type]: Yup.string().required('  '),
  [Fields.date]: Yup.string().required('  '),
  [Fields.amount]: Yup.string().required('  ')
});
